<template>
  <v-container class="col-12">
    <v-card class="pa-4 pb-1">
      <v-row class="mx-0" style="white-space: nowrap">
        <select-project
          v-if="!options.hideProjectSelector && !options.projectSearch"
          v-model="project"
          :class="{'report-base-filter': !options.multiple, 'report-multiple-combobox': options.multiple}"
          :multiple="options.multiple"
          style="min-width: 200px"
        ></select-project>
        <date-picker
          v-model="c1_from"
          label="C1 Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-model="c1_to"
          label="C1 Date To"
          style="max-width: 140px"
        />

        <date-picker
          v-model="c2_from"
          label="C2 Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-model="c2_to"
          label="C2 Date To"
          style="max-width: 140px"
        />

        <v-btn color="info" v-on:click="search" class="mt-2" :disabled="loading" :loading="loading">Search</v-btn>
        <export :fields="exportFields" :data="filteredItems" :reportName="title" :project="project" :report="{url: url, c1_from: c1_from, c1_to: c1_to, c2_from: c2_from, c2_to: c2_to, ...defaultParams, ...tableOptions, entity_id: this.project}" />
      </v-row>
      <small class="d-block ml-2" style="color: rgba(0, 0, 0, 0.6); margin-top: -6px">CR = (C1 - C2 - C2FTD)/C1 * 100</small>
    </v-card>


    <v-card class="col-12 pt-4 pb-4 px-0 mt-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        sort-by="created"
        sort-desc
        :height="`calc(100vh - 165px - ${options.accountType  || options.login ? 40 : 0}px - ${options.selectGame || options.selectSystemBrand ? 60 : 0}px - ${!options.pagination && filteredItems.length < 1000 ? 0 : 40}px - ${!options.padding ? 0 : options.padding}px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        fixed-header
        calculate-widths
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :hide-default-footer="!options.pagination && filteredItems.length < 1000"
        :items-per-page="options.perpage || (!options.perpage && filteredItems.length > 1000 ? 1000 : null) || -1"
        :footer-props="{'items-per-page-options': options.perpage ? ( options.perpage_list || [30, 60, 90]) : [(filteredItems.length > 1000 ? 1000 : null) || -1]}"
        :class="{nowrap, 'table-size-fixed': table_size_fixed, 'report-dt': true}"
        style="z-index: 0; position: relative; width: 100%"
      >
        <template v-slot:item.row_num="{ index }">
          <span>{{ index + 1 }}</span>
        </template>

        <template v-slot:body.prepend>
          <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                single-line
                class="data-table-finance-filter-select"
                :items="filters[header.value].values || columnValueList(header.value)"
                :style="{width: (filters[header.value] || {width: false}).width}"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width}"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
  @import '@/assets/table/report-table.scss';
</style>

<script>
  import moment from 'moment'
  import { find, get, map, filter, reduce, round, uniq, debounce, range, includes, toString, isArray } from 'lodash'
  import { API } from '@/utils/api'
  import { duplicatesFlags } from '@/utils/helper'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    props: { title: {}, headers: {}, filters: {}, url: {}, defaultParams: { default: () => ({}) }, nowrap: { default: true }, table_size_fixed: { default: false }, options: { default: () => ({}) } },

    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },

    data () {
      return {
        totalItems: -1,
        tableOptions: {},
        project: this.options.multiple ? [] : null,
        loading: false,
        totalRow: false,
        totalRows: false,
        items: [],
        filtersD: {},
        c1_from: moment().add(-1, 'month').format('YYYY-MM-01'),
        c1_to: moment().add(-1, 'month').add(-1, 'day').format('YYYY-MM-DD'),
        c2_from: moment().format('YYYY-MM-01'),
        c2_to: moment().add(-1, 'day').format('YYYY-MM-DD'),
      }
    },

    computed: {

      exportFields: function () {
        return map(this.headers, 'value')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filtersD).every(f => {
            try {
              if (this.filtersD[f].data.length > 1 && typeof this.filtersD[f].data == 'string' && this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filtersD[f].data
                if (this.filtersD[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filtersD[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filtersD[f].data.length < 1
              || ((this.filtersD[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filtersD[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filtersD[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filtersD[f].data.toString().toLowerCase()) >= 0))
          })
        })
      }
    },

    watch: {
      tableOptions: {
        handler () {
          if (this.options.pagination && this.totalItems != -1) {
            this.search()
          }
        },
        deep: true,
      },
      filters: {
        handler: debounce(function () {
          this.filtersD = this.filters
        }, 800),
        deep: true,
      },
    },

    methods: {
      round,
      get,

      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

      search: function () {
        this.loading = true
        try {

          API.call(this.url, {
            c1_from: this.c1_from,
            c1_to: this.c1_to,
            c2_from: this.c2_from,
            c2_to: this.c2_to,
            ...this.defaultParams,
            ...this.tableOptions
          }, null, isArray(this.project) ? this.project[0] : this.project).then(resp => {

            this.items = get(resp, 'data', [])
            if (get(resp, 'pagination', false)) {
              this.totalItems = resp.pagination.total
            }
            if (get(resp, 'totalRow', false)) {
              this.totalRow = resp.totalRow
            }
            if (get(resp, 'totalRows', false)) {
              this.totalRows = resp.totalRows
            }

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        return filter(this.items.map(d => get(d, val)), (i) => i)
      }
    },
  }
</script>
